
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.666 5h-30a1.5 1.5 0 000 3v16.5a3 3 0 003 3h10.5v3a1.5 1.5 0 003 0v-3h10.5a3 3 0 003-3V8a1.5 1.5 0 000-3zM18.575 18.059a6.01 6.01 0 01-7.32 4.779c-2.17-.495-3.93-2.256-4.425-4.425a6.01 6.01 0 014.779-7.32.91.91 0 011.058.899V17h5.009a.91.91 0 01.898 1.059zM30.666 20a1.5 1.5 0 01-1.5 1.5h-6a1.5 1.5 0 010-3h6a1.5 1.5 0 011.5 1.5zm-9-6a1.5 1.5 0 011.5-1.5h6a1.5 1.5 0 010 3h-6a1.5 1.5 0 01-1.5-1.5z","fill":"#fff"}})])
          )
        }
      }
    